export const version = 'kunde-v1.20.0-SNAPSHOT-c0dbf6d22f996f899c39eb8b4e7895d6e496e058';